import React, { useEffect, useRef, useState } from 'react'
import ReactECharts from 'echarts-for-react'
import loading from '@/assets/images/loading.gif'
import './comon0.css'
import { FullscreenExitOutlined, FullscreenOutlined } from '@ant-design/icons'
import * as echarts from 'echarts'
import logo3_1 from '../../assets/images/待处理@2x.png'
import logo3_2 from './image/待处理 (1).svg'
import logo3_3 from '../../assets/images/已完结@2x.png'
import leftLogo from '../../assets/images/leftLogo.png'
import centerLogo from '../../assets/images/centerLogo.png'
import rightLogo from '../../assets/images/rightLogo.png'
import local from './image/local.svg'
import local1 from './image/local copy.svg'
import showShopIcon from './image/showShopIcon.svg'
import elseIcon from './image/elseIcon.svg'
import detialType from './image/分类.png'
import returnHome from './image/返回.png'
import time from './image/time.svg'
import smallLogo from './image/编组 5@2x.png'
import { homeService } from './homeService'
import useGlobalModel from '@/model/globalModel'
import { bigNumber } from '@/utils/utils'
import { useDictModel } from '../base/dict/dictModel'
import { DictCodeEnmu } from '@/types/VrmSaDictEnums'
import ChartGpt from './ChartGpt'

// 注册中国地图
echarts.registerMap('china', require('./中华人民共和国.json'));

export function Home() {
    const { shopAndOrg: { shopId, shopType, shopName }, user: { userName } } = useGlobalModel()
    const [currentTime, setCurrentTime] = useState('')
    const [isLoading, setIsLoading] = useState(true)
    const [showFull, setShowFull] = useState(false)
    const [apiData1, setApiData1] = useState<any>([])
    const [apiData2, setApiData2] = useState<any>([])
    const [apiData3, setApiData3] = useState<any>([])
    const [apiVal3, setApiVal3] = useState<any>({})
    const [apiData4, setApiData4] = useState<any>([])
    const [apiData5, setApiData5] = useState<any>([])
    const [apiData6, setApiData6] = useState<any>([])
    const [apiData7, setApiData7] = useState<any>([])
    const { getSelectedDictOne } = useDictModel()
    const timeRef = useRef<HTMLSpanElement>(null);
    const chartRef6 = useRef<any>(null);
    const [activeButton, setActiveButton] = useState('all');

    const handleButtonClick = (buttonName: any) => {
        setActiveButton(buttonName);
    };

    // 中国地图配置 - 增加鼠标悬停显示省份功能
    const mapOption = {
        backgroundColor: 'transparent',
        tooltip: {
            trigger: 'item',
            formatter: function (params: any) {
                return `${params.name}`;
            },
            backgroundColor: '#191175',
            borderColor: '#0D8FFF',
            textStyle: {
                color: '#fff',
                fontSize: 14
            }
        },
        geo: {
            map: 'china',
            roam: false,
            layoutCenter: ['50%', '50%'],
            layoutSize: '100%',
            label: {
                show: false
            },
            itemStyle: {
                areaColor: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                        offset: 0,
                        color: '#191175'
                    }, {
                        offset: 1,
                        color: '#09329d'
                    }]
                },
                borderColor: '#0D8FFF',
                borderWidth: 1
            },
            emphasis: {
                itemStyle: {
                    areaColor: '#0d155d'
                },
                label: {
                    show: true,
                    color: '#fff',
                    fontSize: 12,
                    fontWeight: 'bold'
                }
            },
            select: {
                itemStyle: {
                    areaColor: '#0d155d'
                },
                label: {
                    show: true,
                    color: '#fff'
                }
            }
        },
        series: [
            {
                type: 'scatter',
                coordinateSystem: 'geo',
                symbolSize: 0,
                label: {
                    show: false
                },
                itemStyle: {
                    color: '#fff'
                }
            }
        ]
    };

    //车辆品牌分析
    const fetchData1 = async () => {
        try {
            const data = { shopId, shopType }
            let { retData } = await homeService.carBrand(data)
            setApiData1(retData)
        } catch (error) {
            console.error('接口错误:', error)
        }
    }
    //维修类型分析
    const fetchData2 = async () => {
        try {
            const data = { shopId, shopType, timeType: activeButton }
            let { retData }: any = await homeService.maintenanceType(data)
            let newLiat: any = getSelectedDictOne(DictCodeEnmu.REPAIR_TYPE).length > 0 ? getSelectedDictOne(DictCodeEnmu.REPAIR_TYPE) : [
                {
                    "label": "其他",
                    "value": "repair-type.008",
                    "disabled": false
                },
                {
                    "label": "领取",
                    "value": "repair-type.007",
                    "disabled": false
                },
                {
                    "label": "维修服务",
                    "value": "repair-type.006",
                    "disabled": false
                },
                {
                    "label": "救援",
                    "value": "repair-type.005",
                    "disabled": false
                },
                {
                    "label": "返修",
                    "value": "repair-type.004",
                    "disabled": false
                },
                {
                    "label": "电车检查",
                    "value": "repair-type.003",
                    "disabled": false
                },
                {
                    "label": "二级保养",
                    "value": "repair-type.002",
                    "disabled": false
                },
                {
                    "label": "一级保养",
                    "value": "repair-type.001",
                    "disabled": false
                }
            ]
            let newData: any = newLiat.map((list: any) => {
                if (retData.find((item: any) => list.label == item.serviceNatureName)) {
                    return retData.find((item: any) => list.label == item.serviceNatureName)
                } else {
                    return {
                        carNum: 0,
                        count: 0,
                        serviceNatureName: list.label
                    }
                }
            }).sort((a: any, b: any) => b.count - a.count)
            setApiData2(newData)
        } catch (error) {
            console.error('接口错误:', error)
        }
    }
    //维修状态分析(单)
    const fetchData3 = async () => {
        try {
            const data = { shopId, shopType, timeType: activeButton }
            let { retData }: any = await homeService.maintenanceStatus(data)
            let total: any = retData?.reduce((a: any, b: any) => {
                return a + b.count
            }, 0)
            if (total == 0) {
                total = 1
            }
            let list = ['已开单', '待修', '在修', '已完工', '审核中', '审核通过', '已终检', '已结算']
            let newList: any = []
            list.map((item) => {
                if (retData.find((list: any) => list.statusName == item)) {
                    let data = retData.find((list: any) => list.statusName == item)
                    newList.push({
                        ...data,
                        proportion: ((data.count / total) * 100).toFixed(2) + '%'
                    })
                }
                else {
                    newList.push({
                        count: 0,
                        statusName: item,
                        proportion: '0%'
                    })
                }
            })
            setApiData3(newList)
            const okVal = retData.find((item: any) => item.statusName === '已结算')?.count ?? 0
            const okValPercentage = ((okVal / total) * 100).toFixed(2) + '%'
            const finishNum = retData.filter((item: any) => (item.statusName === '已完工' || item.statusName === '已终检'))
            const finishVal = finishNum.reduce((sum: any, item: any) => sum + item?.count, 0) ?? 0
            const finishValPercentage = ((finishVal / total) * 100).toFixed(2) + '%'
            const otherBrands = retData.filter((item: any) => !(item.statusName == '已结算' || item.statusName == '已完工' || item.statusName === '已终检'))
            const elseVal = otherBrands.reduce((sum: any, item: any) => sum + item?.count, 0) ?? 0
            const elseValPercentage = ((elseVal / total) * 100).toFixed(2) + '%'
            setApiVal3({ okVal: okVal, okValPercentage, finishVal: finishVal, finishValPercentage, elseVal, elseValPercentage })
        } catch (error) {
            console.error('接口错误:', error)
        }
    }
    //车辆年份展示(台)
    const fetchData4 = async () => {
        try {
            const data = { shopId, shopType }
            let { retData } = await homeService.carYear(data)
            setApiData4(retData)
        } catch (error) {
            console.error('接口错误:', error)
        }
    }
    //维修类型分析
    const fetchData5 = async () => {
        try {
            const data = { shopId, shopType, timeType: activeButton }
            let { retData } = await homeService.carType(data)
            setApiData5(retData)
        } catch (error) {
            console.error('接口错误:', error)
        }
    }
    //维修类型分析
    const fetchData6 = async () => {
        try {
            const data = { shopId, shopType, timeType: activeButton }
            let { retData } = await homeService.faultType(data)
            setApiData6(retData?.detail ?? [])
        } catch (error) {
            console.error('接口错误:', error)
        }
    }
    //维修类型分析
    const fetchData7 = async () => {
        try {
            const data = { shopId, shopType, timeType: activeButton }
            let { retData } = await homeService.point(data)
            setApiData7(retData)
        } catch (error) {
            console.error('接口错误:', error)
        }
    }
    const fetchAllData = async () => {
        setApiData1([])
        setApiData2([])
        setApiData3([])
        setApiVal3({})
        setApiData4([])
        setApiData5([])
        setApiData6([])
        setApiData7([])
        await Promise.all([
            fetchData1(),
            fetchData2(),
            fetchData3(),
            fetchData4(),
            fetchData5(),
            fetchData6(),
            fetchData7()
        ])
    }

    useEffect(() => {
        fetchAllData()

        const tenMinInterval = 5 * 60 * 1000
        const twentySecInterval = 20 * 1000

        const interval1 = setInterval(fetchData1, tenMinInterval)
        const interval2 = setInterval(fetchData2, tenMinInterval)
        const interval3 = setInterval(fetchData3, tenMinInterval)
        const interval4 = setInterval(fetchData4, tenMinInterval)
        const interval5 = setInterval(fetchData5, tenMinInterval)
        const interval6 = setInterval(fetchData6, tenMinInterval)
        const interval7 = setInterval(fetchData7, tenMinInterval)

        const fastInterval = setInterval(fetchData7, twentySecInterval)

        return () => {
            clearInterval(interval1)
            clearInterval(interval2)
            clearInterval(interval3)
            clearInterval(interval4)
            clearInterval(interval5)
            clearInterval(interval6)
            clearInterval(interval7)
            clearInterval(fastInterval)
        }
    }, [shopId, activeButton])
    useEffect(() => {
        const updateTime = () => {
            const dt = new Date();
            const datePart = `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, '0')}-${dt.getDate().toString().padStart(2, '0')}`;
            const timePart = `${dt.getHours().toString().padStart(2, '0')}:${dt.getMinutes().toString().padStart(2, '0')}:${dt.getSeconds().toString().padStart(2, '0')}`;
            if (timeRef.current) {
                timeRef.current.textContent = `${datePart}  ${timePart}`;
            }
        };

        updateTime();
        const intervalId = setInterval(updateTime, 1000);

        return () => clearInterval(intervalId);
    }, []);

    useEffect(() => {
        changeSize()
    }, [])

    const changeSize = async () => {
        const setRootFontSize = () => {
            const _width = 1920
            const _height = 1080
            const chartsWrapElement = document.querySelector('#ChartsWrap') as HTMLElement
            const chartsMainElement = document.querySelector('#ChartsMain') as HTMLElement | null

            if (chartsWrapElement && chartsMainElement) {
                const wrapWidth = chartsWrapElement.clientWidth
                const wrapHeight = chartsWrapElement.clientHeight

                const scaleX = wrapWidth / _width
                const scaleY = wrapHeight / _height
                const scale = Math.min(scaleX, scaleY)

                document.documentElement.style.fontSize = `110px`
                chartsMainElement.style.transform = `scale(${scale})`
                chartsMainElement.style.transformOrigin = 'center center'
            } else {
                console.error('Element with id \'ChartsWrap\' or \'ChartsMain\' not found.')
            }
        }

        setRootFontSize()
        window.addEventListener('resize', setRootFontSize)

        const timer = setTimeout(() => setIsLoading(false), 1000)

        return () => {
            document.documentElement.style.fontSize = ''
            window.removeEventListener('resize', setRootFontSize)
            clearTimeout(timer)
        }
    };

    //车辆品牌分析
    let color1 = ['#CA51FF', '#66A4FF', '#65FFFF', '#65FFC3', '#55F4B5', '#A6F533', '#F58E33', '#F5335C']
    const color1List = [
        new echarts.graphic.LinearGradient(.3, 1, .8, .1, [{
            offset: 0,
            color: '#CA51FF'
        }, {
            offset: 1,
            color: '#744FFE'
        }]),
        new echarts.graphic.LinearGradient(0, .5, 1, .7, [{
            offset: 0,
            color: '#66A4FF'
        }, {
            offset: 1,
            color: '#3361F5'
        }]),
        new echarts.graphic.LinearGradient(.1, 0, .1, 1, [{
            offset: 0,
            color: '#65FFFF'
        }, {
            offset: 1,
            color: '#17A2FA'
        }]),
        new echarts.graphic.LinearGradient(1, .5, 0, .7, [{
            offset: 0,
            color: '#65FFC3'
        }, {
            offset: 1,
            color: '#15DFE4'
        }]),
        new echarts.graphic.LinearGradient(1, .7, .6, .1, [{
            offset: 0,
            color: '#55F4B5'
        }, {
            offset: 1,
            color: '#34FF66'
        }]),
        new echarts.graphic.LinearGradient(.1, 0, .1, 1, [{
            offset: 0,
            color: '#A6F533'
        }, {
            offset: 1,
            color: '#FFF070'
        }]),
        new echarts.graphic.LinearGradient(1, .5, 0, .7, [{
            offset: 0,
            color: '#F58E33'
        }, {
            offset: 1,
            color: '#FFC365'
        }]),
        new echarts.graphic.LinearGradient(1, .7, .6, .1, [{
            offset: 0,
            color: '#F5335C'
        }, {
            offset: 1,
            color: '#FF74A5'
        }])
    ]
    const list1: any = apiData1.map((item: any) => {
        return {
            value: item.count,
            name: item.brandName,
            proportion: (+item.proportion).toFixed(2)
        }
    })
    const maxCountItem1 = apiData1.length > 0
        ? apiData1.reduce((max: any, item: any) => item.count > max.count ? item : max).count * 2
        : 0
    let series: any = [],
        length = list1.length, maxRaduis = [90, 10],
        radiusWidth = (maxRaduis[0] - maxRaduis[1]) / length
    list1.forEach((info: any, i: any) => {
        let outRadius = (length - i - 1) * radiusWidth + maxRaduis[1],
            radius = [outRadius + 3.5 + '%', (outRadius + radiusWidth) + '%'],
            center = ['25%', '47%']
        series.push({
            type: 'pie',
            clockWise: false,
            hoverAnimation: false,
            radius,
            center,
            min: 0,
            max: 200,
            label: {
                show: true,
                position: 'inside',
                fontSize: 11,
                color: '#fff',
                padding: [5, 0, 0, 100],
                formatter: function (params: any) {
                    let item: any = list1[i];
                    return `{line|——}{circle|●}{name| ${item.proportion}%}`;
                },
                textStyle: {
                    color: '#F7FBFF',
                    rich: {
                        line: {
                            width: 30,
                            height: 10,
                            color: '#F7FBFF',
                            align: 'left'
                        },
                        circle: {
                            color: color1[i],
                            fontSize: 12,
                            padding: [0, 1],
                            align: 'left'
                        },
                        name: {
                            color: '#F7FBFF',
                            fontSize: 12,
                            width: 42,
                            align: 'left'
                        }
                    }
                }
            },
            labelLine: {
                show: false
            },
            data: [{
                value: 0,
                itemStyle: {
                    color: color1List[i],
                    borderRadius: 30
                }
            }, {
                value: info.value,
                name: info.name,
                itemStyle: {
                    color: color1List[i],
                    borderRadius: 30
                },
                tooltip: {
                    show: false
                },
                label: {
                    show: false
                }
            }, {
                value: maxCountItem1 - info.value,
                itemStyle: {
                    color: 'rgba(0,0,0,0)'
                },
                tooltip: {
                    show: false
                },
                label: {
                    show: false
                }
            }]
        })
        series.push({
            type: 'pie',
            silent: true,
            z: 1,
            clockWise: false,
            hoverAnimation: false,
            min: 0,
            max: 200,
            radius,
            center,
            label: {
                show: false
            },
            data: [{
                value: 5,
                itemStyle: {
                    color: 'rgb(0,0,255,.1)',
                    borderRadius: 30
                },
                tooltip: {
                    show: false
                }
            }, {
                value: 5,
                itemStyle: {
                    color: 'rgba(0,0,0,0)',
                    borderRadius: 30
                },
                tooltip: {
                    show: false
                }
            }]
        })
    })

    const option1 = {
        legend: {
            show: true,
            orient: 'vertical',
            icon: 'circle',
            top: 15,
            left: 360,
            itemWidth: 10,
            itemHeight: 10,
            data: list1,
            itemGap: 10,
            formatter: function (name: any, index: any) {
                let data = list1.find((item: any) => item.name == name)
                return '{name|' + name + '  ' + data.value + '台' + '}'
            },
            textStyle: {
                rich: {
                    name: {
                        fontSize: 14,
                        fontWeight: 300,
                        color: '#fff ',
                        padding: [0, 0, 0, 2]
                    }
                }
            }
        },
        series
    }

    // 车辆类型分析
    var data2_1: any = apiData2.map((item: any) => {
        return {
            value: item.count,
            name: item.serviceNatureName
        }
    })
    var data2_2: any = apiData2.map((item: any) => {
        return {
            value: item.carNum,
            name: item.serviceNatureName
        }
    })

    const option2 = {
        color: [
            {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                    {
                        offset: 0,
                        color: '#48DFFE'
                    },
                    {
                        offset: 1,
                        color: '#51A6FC'
                    }
                ],
                global: false
            },
            {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                    {
                        offset: 0,
                        color: '#2774FF'
                    },
                    {
                        offset: 1,
                        color: '#AD34FF'
                    }
                ],
                global: false
            }
        ],
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            formatter: (params: any) => {
                return params.map((item: any) => {
                    return `${item.name}: ${Math.abs(item.value)}`
                }).join('<br/>')
            }
        },
        grid: {
            left: 10,
            top: 35,
            right: 40,
            bottom: 55,
            containLabel: true
        },
        xAxis: {
            type: 'category',
            data: data2_1.map((item: any) => item.name),
            axisTick: {
                alignWithLabel: true
            },
            axisLine: {
                lineStyle: {
                    color: '#eee',
                    width: 1
                }
            },
            axisLabel: {
                textStyle: {
                    color: '#fff',
                    fontStyle: 'normal',
                    fontFamily: '微软雅黑',
                    fontWeight: 300,
                    fontSize: 13,
                    lineHeight: 35,

                },
                interval: 0
            },
            splitLine: {
                show: false
            }
        },
        legend: {
            icon: 'rect',
            orient: 'horizontal',
            top: 0,
            right: '10%',
            itemWidth: 10,
            itemHeight: 10,
            itemGap: 20,
            textStyle: {
                color: '#fff',
                fontSize: 14,
                fontWeight: 300
            },
            data: ['维修单量', '维修台次']
        },
        yAxis: {
            type: 'value',
            axisLabel: {
                formatter: (value: any) => (value >= 0 ? value : Math.abs(value))
            },
            splitLine: {
                lineStyle: {
                    type: 'dashed',
                    color: '#2A3F76',
                    width: 1
                }
            },
            axisLine: {
                show: true,
                onZero: false,
                lineStyle: {
                    type: 'solid',
                    color: '#fff'
                }
            },
            axisTick: {
                show: false
            },
            minorTick: {
                splitNumber: 5
            }
        },
        series: [
            {
                name: '维修单量',
                type: 'bar',
                barGap: '0%',
                barCategoryGap: '10%',
                barWidth: 16,
                borderRadius: [30, 30, 0, 0],
                data: data2_1.map((item: any) => item.value),
                stack: 'stack',
                itemStyle: {
                    borderRadius: [20, 20, 0, 0]
                },
                label: {
                    show: true,
                    position: 'top',
                    color: '#fff',
                    fontSize: 13,
                    formatter: (params: any) => Math.abs(params.value),
                    padding: [0, 5],
                }
            },
            {
                name: '维修台次',
                type: 'bar',
                barGap: '0%',
                barCategoryGap: '20%',
                barWidth: '30%',
                borderRadius: [0, 0, 30, 30],
                data: data2_2.map((item: any) => -item.value),
                stack: 'stack',
                itemStyle: {
                    borderRadius: [0, 0, 20, 20]
                },
                label: {
                    show: true,
                    position: 'bottom',
                    color: '#fff',
                    fontSize: 13,
                    formatter: (params: any) => Math.abs(params.value),
                    padding: [0, 5]
                }
            }
        ]
    };

    //维修状态分析(单)
    const color3List = [
        new echarts.graphic.LinearGradient(.3, 1, .8, .1, [{
            offset: 0,
            color: '#66A4FF'
        }, {
            offset: 1,
            color: '#3361F5'
        }]),
        new echarts.graphic.LinearGradient(0, .5, 1, .7, [{
            offset: 0,
            color: '#65FFFF'
        }, {
            offset: 1,
            color: '#17A2FA'
        }]),
        new echarts.graphic.LinearGradient(.1, 0, .1, 1, [{
            offset: 0,
            color: '#65FFC3'
        }, {
            offset: 1,
            color: '#15DFE4'
        }]),
        new echarts.graphic.LinearGradient(1, .5, 0, .7, [{
            offset: 0,
            color: '#55F4B5'
        }, {
            offset: 1,
            color: '#34FF66'
        }]),
        new echarts.graphic.LinearGradient(1, .7, .6, .1, [{
            offset: 0,
            color: '#F58E33'
        }, {
            offset: 1,
            color: '#FFC365'
        }]),
        new echarts.graphic.LinearGradient(1, .5, 0, .7, [{
            offset: 0,
            color: '#F5335C'
        }, {
            offset: 1,
            color: '#FF74A5'
        }]),
        new echarts.graphic.LinearGradient(.1, 0, .1, 1, [{
            offset: 0,
            color: '#A6F533'
        }, {
            offset: 1,
            color: '#FFF070'
        }])
    ]
    const pieData3: any = apiData3.map((item: any) => {
        return {
            value: item.count,
            name: item.statusName,
            proportion: item.proportion
        }
    })
    const total3 = pieData3.reduce((a: any, b: any) => {
        return a + b.value
    }, 0)
    const option3 = {
        title: {
            text: '{a|' + total3 + '}',
            subtext: `工单总量`,
            x: '30%',
            y: '27%',
            textAlign: 'center',
            textStyle: {
                color: '#b4e4ff',
                rich: {
                    a: {
                        color: '#83fff8',
                        fontSize: 20,
                        fontWeight: 'bolder',
                        lineHeight: 21,
                        align: 'center'
                    },
                    b: {
                        fontSize: 12,
                        color: '#fff'
                    }
                }
            },
            subtextStyle: {
                fontSize: 13,
                color: '#fff',
                fontWeight: 300,
            }
        },
        tooltip: {
            trigger: 'item'
        },
        legend: {
            icon: 'circle',
            orient: 'horizontal',
            top: 215,
            left: 0,
            itemWidth: 10,
            itemHeight: 10,
            textStyle: {
                color: '#fff',
                fontSize: 12,
                fontWeight: 300
            },
            data: pieData3.map((r: any) => r.name),
            width: 500,
        },
        grid: {
            left: 15,
            top: 35,
            right: 40,
            bottom: 155,
            containLabel: true
        },
        series: [
            {
                name: '维修状态',
                type: 'pie',
                radius: ['31%', '42%'],
                center: ['31%', '35%'],
                avoidLabelOverlap: false,
                label: {
                    position: 'outside',
                    color: '#E6F7FF',
                    lineHeight: 18,
                    formatter: (params: any) => {
                        const { data } = params;
                        return data.name ? `${data.name}\n${data.value}单 ${data.proportion}` : '';
                    },
                    textStyle: {
                        color: '#E1FEFF',
                        fontSize: 12,
                        fontWeight: 300,
                    },
                },
                itemStyle: {
                    borderColor: 'transparent'
                },
                emphasis: {
                    scaleSize: 10
                },
                data: pieData3.map((val: any, index: any) => {
                    return {
                        ...val,
                        percent: 1,
                        itemStyle: {
                            normal: {
                                color: color3List[index]
                            }
                        }
                    };
                })
            },
            {
                name: '阴影圈',
                type: 'pie',
                radius: ['26.5%', '27%'],
                center: ['31%', '35%'],
                emphasis: {
                    scale: false
                },
                tooltip: {
                    show: false
                },
                itemStyle: {
                    color: '#0d4f91'
                },
                zlevel: 4,
                labelLine: {
                    show: false
                },
                data: [100]
            },
            {
                name: '阴影圈',
                type: 'pie',
                radius: ['22.5%', '23%'],
                center: ['31%', '35%'],
                emphasis: {
                    scale: false
                },
                tooltip: {
                    show: false
                },
                itemStyle: {
                    color: '#0d4f91'
                },
                zlevel: 4,
                labelLine: {
                    show: false
                },
                data: [100]
            }
        ]
    };

    const pieData4_1: any = apiData4?.threeYearDetail?.map((item: any) => {
        return {
            value: item.count,
            name: item.categoryName,
            proportion: (+item.proportion).toFixed(2)
        }
    }) ?? []
    //车辆年份展示(台)
    const option4_1 = {
        title: {
            text: '{a|' + apiData4?.threeYear + '}',
            subtext: `3年以下`,
            x: '48%',
            y: 37,
            textAlign: 'center',
            textStyle: {
                color: '#b4e4ff',
                fontWeight: 'normal',
                rich: {
                    a: {
                        color: '#82DFBE',
                        fontSize: 20,
                        fontWeight: 'bolder',
                        align: 'center'
                    },
                    b: {
                        fontSize: 13,
                        color: '#FFFFFF'
                    }
                }
            },
            subtextStyle: {
                fontSize: 12,
                fontWeight: 'normal',
                color: '#fff'
            }
        },
        tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c} ({d}%)',
            position: function (p: any) {
                return [p[0] + 10, p[1] - 10]
            }
        },
        legend: {
            icon: 'circle',
            orient: 'vertical',
            top: 120,
            left: 15,
            itemWidth: 10,
            itemHeight: 10,
            data: pieData4_1,
            formatter: function (name: any, index: any) {
                let data = pieData4_1.find((item: any) => item.name == name)
                return '{name|' + name + '}{num|' + '  ' + data.value + '/' + data.proportion + '%' + '}'
            },
            textStyle: {
                rich: {
                    name: {
                        fontSize: 13,
                        color: '#fff',
                        fontWeight: 300,
                        width: 42,
                        align: 'left'
                    },
                    num: {
                        fontSize: 13,
                        color: '#fff',
                        fontWeight: 300
                    }
                }
            }
        },
        series: [
            {
                name: '3年以下',
                type: 'pie',
                center: ['50%', '20%'],
                radius: ['40%', '65%'],
                color: ['#4ECB73', '#4ECB9B', '#36CBCB', '#82DFBE', '#ABDF82'],
                label: { show: false },
                labelLine: { show: false },
                data: pieData4_1?.map((item: any) => {
                    return {
                        ...item,
                        itemStyle: {
                            normal: {
                                borderWidth: 5,
                                borderColor: '#0a1754'
                            }
                        }
                    }
                })
            }
        ]
    }
    const pieData4_2: any = apiData4?.threeToFiveYearDetail?.map((item: any) => {
        return {
            value: item.count,
            name: item.categoryName,
            proportion: (+item.proportion).toFixed(2)
        }
    }) ?? []
    const option4_2 = {
        title: {
            text: '{a|' + apiData4?.threeToFiveYear + '}',
            subtext: `3~5年`,
            x: '48%',
            y: 37,
            textAlign: 'center',
            textStyle: {
                color: '#b4e4ff',
                rich: {
                    a: {
                        color: '#3AA0FF',
                        fontSize: 20,
                        fontWeight: 'bolder',
                        align: 'center'
                    },
                    b: {
                        fontSize: 13,
                        color: '#FFFFFF'
                    }
                }
            },
            subtextStyle: {
                fontSize: 12,
                fontWeight: 'normal',
                color: '#fff'
            }
        },
        tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c} ({d}%)',
            position: function (p: any) {
                return [p[0] + 10, p[1] - 10]
            }
        },
        legend: {
            icon: 'circle',
            orient: 'vertical',
            top: 120,
            left: 15,
            itemWidth: 10,
            itemHeight: 10,
            data: pieData4_2,
            formatter: function (name: any, index: any) {
                let data = pieData4_2.find((item: any) => item.name == name)
                return '{name|' + name + '}{num|' + '  ' + data.value + '/' + data.proportion + '%' + '}'
            },
            textStyle: {
                rich: {
                    name: {
                        fontSize: 13,
                        color: '#fff',
                        fontWeight: 300,
                        width: 42,
                        align: 'left'
                    },
                    num: {
                        fontSize: 13,
                        color: '#fff',
                        fontWeight: 300
                    }
                }
            }
        },
        series: [
            {
                name: '3~5年',
                type: 'pie',
                center: ['50%', '20%'],
                radius: ['40%', '65%'],
                color: ['#743AFF', '#3A49FF', '#3AA0FF', '#3AE9FF', '#3AFFDC'],
                label: { show: false },
                labelLine: { show: false },
                data: pieData4_2.map((item: any) => {
                    return {
                        ...item,
                        itemStyle: {
                            normal: {
                                borderWidth: 5,
                                borderColor: '#0a1754'
                            }
                        }
                    }
                })
            }
        ]
    }
    const pieData4_3: any = apiData4?.fiveYearDetail?.map((item: any) => {
        return {
            value: item.count,
            name: item.categoryName,
            proportion: (+item.proportion).toFixed(2)
        }
    }) ?? []
    const option4_3 = {
        title: {
            text: '{a|' + apiData4?.fiveYear + '}',
            subtext: `5年以上`,
            x: '48%',
            y: 37,
            textAlign: 'center',
            textStyle: {
                color: '#b4e4ff',
                fontWeight: 'normal',
                rich: {
                    a: {
                        color: '#82DFBE',
                        fontSize: 20,
                        fontWeight: 'bolder',
                        align: 'center'
                    },
                    b: {
                        fontSize: 13,
                        color: '#FFFFFF'
                    }
                }
            },
            subtextStyle: {
                fontSize: 12,
                fontWeight: 'normal',
                color: '#fff'
            }
        },
        tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c} ({d}%)',
            position: function (p: any) {
                return [p[0] + 10, p[1] - 10]
            }
        },
        legend: {
            icon: 'circle',
            orient: 'vertical',
            top: 120,
            left: 15,
            itemWidth: 10,
            itemHeight: 10,
            data: pieData4_3,
            formatter: function (name: any, index: any) {
                let data = pieData4_3.find((item: any) => item.name == name)
                return '{name|' + name + '}{num|' + '  ' + data.value + '/' + data.proportion + '%' + '}'
            },
            textStyle: {
                rich: {
                    name: {
                        fontSize: 13,
                        color: '#fff',
                        fontWeight: 300,
                        width: 42,
                        align: 'left'
                    },
                    num: {
                        fontSize: 13,
                        color: '#fff',
                        fontWeight: 300
                    }
                }
            }
        },
        series: [
            {
                name: '年龄分布',
                type: 'pie',
                center: ['50%', '20%'],
                radius: ['40%', '65%'],
                color: ['#3D7FFF', '#5AFDF2', '#8BE983', '#F7E67F', '#4838FF'],
                label: { show: false },
                labelLine: { show: false },
                data: pieData4_3.map((item: any) => {
                    return {
                        ...item,
                        itemStyle: {
                            normal: {
                                borderWidth: 5,
                                borderColor: '#0a1754'
                            }
                        }
                    }
                })
            }
        ]
    }
    const pieData5: any = apiData5?.map((item: any) => {
        return {
            value: item.count,
            name: item.categoryName,
            proportion: (+item.proportion).toFixed(2) + '%'
        }
    }) ?? []
    //车辆类型分析
    const color5List = [
        new echarts.graphic.LinearGradient(.3, 1, .8, .1, [{
            offset: 0,
            color: '#CA51FF'
        }, {
            offset: 1,
            color: '#744FFE'
        }]),
        new echarts.graphic.LinearGradient(0, .5, 1, .7, [{
            offset: 0,
            color: '#66A4FF'
        }, {
            offset: 1,
            color: '#3361F5'
        }]),
        new echarts.graphic.LinearGradient(.1, 0, .1, 1, [{
            offset: 0,
            color: '#65FFFF'
        }, {
            offset: 1,
            color: '#17A2FA'
        }]),
        new echarts.graphic.LinearGradient(1, .5, 0, .7, [{
            offset: 0,
            color: '#65FFC3'
        }, {
            offset: 1,
            color: '#15DFE4'
        }]),
        new echarts.graphic.LinearGradient(1, .7, .6, .1, [{
            offset: 0,
            color: '#55F4B5'
        }, {
            offset: 1,
            color: '#34FF66'
        }]),
        new echarts.graphic.LinearGradient(.1, 0, .1, 1, [{
            offset: 0,
            color: '#A6F533'
        }, {
            offset: 1,
            color: '#FFF070'
        }]),
        new echarts.graphic.LinearGradient(1, .5, 0, .7, [{
            offset: 0,
            color: '#F58E33'
        }, {
            offset: 1,
            color: '#FFC365'
        }]),
        new echarts.graphic.LinearGradient(1, .7, .6, .1, [{
            offset: 0,
            color: '#F5335C'
        }, {
            offset: 1,
            color: '#FF74A5'
        }])
    ]
    const option5 = {
        tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        label: {
            show: true,
            position: 'outside',
            lineStyle: {
                length: 1,
                length2: 1
            }
        },
        legend: {
            icon: 'circle',
            orient: 'vertical',
            top: 0,
            left: 360,
            itemWidth: 10,
            itemHeight: 10,
            itemGap: 9,
            textStyle: {
                color: '#E1FEFF',
                fontSize: 14,
                padding: [0, 0, 0, 2]
            },
            data: pieData5,
            formatter: function (name: any) {
                let data = pieData5.find((item: any) => item.name == name);
                return name + '  ' + data.value + '单';
            }
        },
        series: [
            {
                name: '车辆类型',
                type: 'pie',
                radius: [15, 100],
                center: ['37%', '40%'],
                roseType: 'area',
                label: {
                    position: 'outside',
                    color: '#E6F7FF',
                    lineHeight: 20,
                    formatter: (params: any) => {
                        const { data } = params;
                        return data.name ? `${data.name}\n${data.value}单 ${data.proportion}` : '';
                    },
                    textStyle: {
                        color: '#E1FEFF',
                        fontSize: 12,
                        fontWeight: 300,
                    },
                },
                labelLine: {
                    length: 5,
                    length2: 3,
                    lineStyle: {
                        width: 1
                    }
                },
                data: pieData5.map((val: any, index: any) => {
                    return {
                        ...val,
                        percent: 5.12,
                        itemStyle: {
                            normal: {
                                color: color5List[index]
                            }
                        }
                    };
                })
            }
        ]
    };

    //故障类型分析
    const data6: any = apiData6?.map((item: any) => {
        return {
            value: item.count,
            name: item.faultType,
            proportion: (+item.proportion).toFixed(2) + '%'
        }
    })
    const maxCountItem6 = apiData6.length > 0
        ? apiData6.reduce((max: any, item: any) => item.count > max.count ? item : max).count
        : 0
    var defaultData = apiData6.map((item: any) => {
        return maxCountItem6
    })
    let getArrByKey = (data: any, k: any) => {
        let key = k || 'value'
        let res: any = []
        if (data) {
            data.forEach(function (t: any) {
                res.push(t[key])
            })
        }
        return res
    }
    let getSymbolData = (data: any) => {
        let arr = []
        for (var i = 0; i < data.length; i++) {
            arr.push({
                value: data[i].value,
                symbolPosition: 'end'
            })
        }
        return arr
    }

    const option6 = {
        grid: {
            top: '2%',
            bottom: 18,
            right: -20,
            left: 10,
            containLabel: true
        },
        xAxis: {
            show: false
        },
        yAxis: [{
            triggerEvent: true,
            show: true,
            inverse: true,
            data: getArrByKey(data6, 'name'),
            axisLine: {
                show: false
            },
            splitLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            axisLabel: {
                show: false,
                interval: 0,
                color: '#fff',
                align: 'left',
                margin: 80,
                fontSize: 13,
                formatter: function (value: any, index: any) {
                    return '{title|' + value + '}'
                },
                rich: {
                    title: {
                        color: 'red',
                        width: 165
                    }
                }
            }
        }, {
            triggerEvent: true,
            show: true,
            inverse: true,
            data: getArrByKey(data6, 'name'),
            axisLine: {
                show: false
            },
            splitLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            axisLabel: {
                interval: 0,
                shadowOffsetX: '-20px',
                color: ['#30FFF3'],
                align: 'right',
                verticalAlign: 'bottom',
                lineHeight: 30,
                fontSize: 20,
                formatter: function (value: any, index: any) {
                    let data = data6.find((item: any) => item.name == value)
                    return `${data.value}/${data.proportion}`
                },
                textStyle: {
                    fontSize: 14,
                    color: '#fff',
                    fontWeight: 300,
                },

            }
        }],
        dataZoom: [
            {
                type: 'inside',
                yAxisIndex: [0, 1],
                startValue: 0,
                endValue: 4,
                zoomLock: false,
                zoomOnMouseWheel: false,
                moveOnMouseMove: true,
                moveOnMouseWheel: true
            },
            {
                type: 'slider',
                yAxisIndex: [0, 1],
                show: false,
                startValue: 0,
                endValue: 4,
                zoomLock: false,
                zoomOnMouseWheel: false,
                moveOnMouseMove: true,
                moveOnMouseWheel: true
            },
        ],
        series: [{
            name: 'XXX',
            type: 'pictorialBar',
            symbol: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA6CAMAAADWZboaAAAAZlBMVEUAAABe3uVe3+Vf3uVf3+Zf3uVg3+Zg3+Zf3+Vi4OZh4OZg3+Z86/Bh3+Zi4Odj4Odi4OZ86/B76/B86/Bj4ed56+9x5+xn4umB7/N87PB36e+A7/N+7fF/7vJ/7vJ+7fGA7/OB7/PReX+lAAAAIXRSTlMABQkVDREmIhk3MR10LEFFPHh7cUprXE35h2XnqMLAp+mHAG9cAAAB5ElEQVRIx83WjU7CMBQFYIoiKMqU/XUboHv/l/Tce7t2XamDNSacETEmX86tlK2rx4py150o+MstMBLwWRfHKo6JCVxLnvmFGBjFQ58oF1//sUZhGy/ClSTWObgnL4O+bkeN4nY2okfNMbkRt9/vtxz8InoTsWplJSCzFxPmO8+GpSIByX3YQAuGDWtRKhKjCnxDXhF6Z4yxnZ20Wgko7BMRDmxtSGVaI4kdTIgb+zTYoJQlIMlDlmUFgrcDWWC201qSayqlTkiCddWWeV62VU0YlnpRi9VOKaSUsiyq/N0krwq2Ugt7lVpZl5BfHNiytjagMi+XYp0kCR45hMlivVQrE/uU5pXSrCB5bM6d1t2lOZItMqmliT3q5uVxqxzyW/ccfYLNKx7ZTeykMvNyac2yt2Fbc61MHLSC0rwoxbiNdlQ3GBm1NLHQsHUrtEXppR/ljNpW6DbSCoqlFiVoN6YdaFlgsSFVPs1BdT8OaB5QyQzVcaqWDows/zepxR8ObLglTrdtCRVuRNj4Rrxh+//0ke2f8KVL+Kon3GCSbmsJN9OUW3j6g0Ns+LgCij2u0h+Sghc8mlMPBMgdx5DFh59VmOVHrvmDnoNxCz3J7MFWsMuaLyR089xz/xhlfijvwutR8gv3zk6BLUUeCgAAAABJRU5ErkJggg==',
            symbolSize: [50, 50],
            symbolOffset: [20, 0],
            z: 12,
            itemStyle: {
                normal: {
                    color: '#fff'
                }
            },
            data: getSymbolData(data6 ?? [])
        }, {
            name: '背景',
            type: 'bar',
            barWidth: 10,
            barGap: '-100%',
            z: 1,
            data: defaultData,
            itemStyle: {
                normal: {
                    color: 'rgb(0,0,255,.1)',
                    barBorderRadius: 30
                }
            }
        }, {
            name: '条',
            type: 'bar',
            showBackground: true,
            barBorderRadius: 30,
            yAxisIndex: 0,
            data: data6,
            barWidth: 10,
            itemStyle: {
                normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                        {
                            offset: 0,
                            color: '#0D8FFF'
                        },
                        {
                            offset: 1,
                            color: '#19FFC4'
                        }
                    ]),
                    barBorderRadius: 10
                },
                barBorderRadius: 4
            },
            label: {
                normal: {
                    color: '#fff',
                    show: true,
                    position: [0, '-25px'],
                    lineHeight: 25,
                    textStyle: {
                        fontSize: 14,
                        color: '#fff',
                        fontWeight: 300
                    },
                    formatter: function (a: any, b: any) {
                        return a.name
                    }
                }
            }
        }]
    }
    useEffect(() => {
        if (!chartRef6.current) return;

        const chart = chartRef6.current.getEchartsInstance();
        if (!chart) return;

        const dataLength = option6.yAxis[0].data.length;
        const visibleCount = 5;

        const autoScroll = () => {
            if (!chart) return;

            const { startValue, endValue } = chart.getOption().dataZoom[0];

            let nextStart = startValue + 1;
            let nextEnd = endValue + 1;

            if (nextEnd > dataLength) {
                nextStart = 0;
                nextEnd = visibleCount;
            }

            option6.dataZoom[0].startValue = nextStart;
            option6.dataZoom[0].endValue = nextEnd;
            option6.dataZoom[1].startValue = nextStart;
            option6.dataZoom[1].endValue = nextEnd;

            chart.setOption(option6);
        };

        const intervalId = setInterval(autoScroll, 2000);

        return () => clearInterval(intervalId);
    }, [option6.yAxis[0].data]);

    return (
        <div className={`smart-dashboard ${showFull ? 'full-screen' : ''}`} id="ChartsWrap">
            <div className="wrapper-box">
                <div className="inner-box" id="ChartsMain">

                    {isLoading && (
                        <div className="loading">
                            <div className="loadbox">
                                <img src={loading} alt="Loading" /> 页面加载中...
                            </div>
                        </div>
                    )}
                    <div className="head">
                        <div className="weather" style={{ whiteSpace: 'pre' }}>
                            <img src={time} alt="站点图标" />
                            <span ref={timeRef}></span>
                        </div>
                        <h1>{`${shopName}车辆数据展示`}</h1>
                        <div className="dataTime" style={{ whiteSpace: 'pre' }}>
                            <div className="button-group">
                                <button
                                    className={`button ${activeButton === 'all' ? 'active' : ''}`}
                                    onClick={() => handleButtonClick('all')}
                                >
                                    全部
                                </button>
                                <button
                                    className={`button ${activeButton === 'year' ? 'active' : ''}`}
                                    onClick={() => handleButtonClick('year')}
                                >
                                    当年
                                </button>
                                <button
                                    className={`button ${activeButton === 'month' ? 'active' : ''}`}
                                    onClick={() => handleButtonClick('month')}
                                >
                                    当月
                                </button>
                            </div>
                            <div
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    setShowFull(!showFull)
                                    setTimeout(() => {
                                        changeSize()
                                    }, 0)
                                }}
                            >
                                {showFull ? <FullscreenExitOutlined style={{ color: '#64E1FF', fontSize: '32px' }} /> :
                                    <FullscreenOutlined style={{ color: '#64E1FF', fontSize: '32px' }} />}
                            </div>

                        </div>
                    </div>
                    <div className="mainbox">
                        <ul className="clearfix">
                            {/* 左侧三个图表 */}
                            <li>
                                <div className="boxall">
                                    <div className="alltitle">
                                        <img src={elseIcon} alt="站点图标" />
                                        车辆品牌分析
                                    </div>
                                    <div className="allnav">
                                        <ReactECharts option={option1}
                                            style={{ width: '100%', height: '100%' }}
                                            opts={{ renderer: 'svg', devicePixelRatio: 2 }}
                                        />
                                    </div>
                                    <div className="boxfoot"></div>
                                </div>
                                <div className="boxall">
                                    <div className="alltitle">
                                        <img src={elseIcon} alt="站点图标" />
                                        车辆类型分析
                                    </div>
                                    <div className="allnav" id="echart5">
                                        <ReactECharts option={option5} style={{ width: '100%', height: '100%' }}
                                            opts={{ renderer: 'svg', devicePixelRatio: 2 }}
                                        />
                                    </div>
                                    <div className="boxfoot"></div>
                                </div>
                                <div className="boxall">
                                    <div className="alltitle">
                                        <img src={elseIcon} alt="站点图标" />
                                        车辆年份展示(台)
                                    </div>
                                    <div style={{ display: 'flex' }}>
                                        <ReactECharts className="sy" option={option4_1}
                                            opts={{ renderer: 'svg', devicePixelRatio: 2 }}
                                        />
                                        <ReactECharts className="sy" option={option4_2}
                                            opts={{ renderer: 'svg', devicePixelRatio: 2 }}
                                        />
                                        <ReactECharts className="sy" option={option4_3}
                                            opts={{ renderer: 'svg', devicePixelRatio: 2 }}
                                        />
                                    </div>
                                    <div className="boxfoot"></div>
                                </div>
                            </li>
                            {/* 中间地图区域 */}
                            <li>
                                <div className="map">
                                    {/* <img src={local} className="location-icon icon1" alt="location" />
                                    <img src={local} className="location-icon icon2" alt="location" />
                                    <img src={local} className="location-icon icon3" alt="location" />
                                    <img src={local1} className="location-icon icon4" alt="location" /> */}
                                    <div className="point-info-container">
                                        <div className="showHeader">
                                            <img src={smallLogo} alt="站点图标" />
                                            <span>站点信息</span>
                                        </div>
                                        <div className="showBody">
                                            <div className="left-section">
                                                <div className="showIcon">
                                                    <img src={showShopIcon} alt="固废中转" />
                                                </div>
                                                <p className="custom-text">{shopName}</p>
                                            </div>
                                            <div className="right-section">
                                                <div className="info-item">
                                                    <span className="label">总维修台次</span>
                                                    <span className="value">{apiData7.totalRepairNum}</span>
                                                </div>
                                                <div className="info-item">
                                                    <span className="label">总维修单量</span>
                                                    <span className="value">{apiData7.totalRepairOrderNum}</span>
                                                </div>
                                                <div className="info-item">
                                                    <span className="label">总一保单量</span>
                                                    <span className="value">{apiData7.totalOneNum}</span>
                                                </div>
                                                <div className="info-item">
                                                    <span className="label">总二保单量</span>
                                                    <span className="value">{apiData7.totalTwoNum}</span>
                                                </div>
                                                <div className="info-item">
                                                    <span className="label">总电车检查</span>
                                                    <span className="value">{apiData7.totalElectricCheckNum}</span>
                                                </div>
                                                <div className="info-item">
                                                    <span className="label">当日进厂量</span>
                                                    <span className="value">{apiData7.todayInNum}</span>
                                                </div>
                                                <div className="info-item">
                                                    <span className="label">当日完工量</span>
                                                    <span className="value">{apiData7.todayFinishNum}</span>
                                                </div>
                                                <div className="info-item">
                                                    <span className="label">当日待处理</span>
                                                    <span className="value">{apiData7.todayWaitNum}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="map1"></div>
                                    <div className="map2"></div>
                                    <div className="map3"></div>
                                    {/* 替换为ECharts中国地图 */}
                                    <ReactECharts
                                        option={mapOption}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            zIndex: 0
                                        }}
                                        opts={{ renderer: 'svg' }}
                                    />
                                </div>
                                <div className="shopTotalNum">
                                    <div className="data-item item1">
                                        <img src={leftLogo} className="shopIcon" alt="待处理图标" />
                                        <div className="data-content">
                                            <div className="shopValue">{apiData7.todayInNum}</div>
                                            <div className="shopText">今日进厂量</div>
                                        </div>
                                    </div>
                                    <div className="data-item item2">
                                        <img src={centerLogo} className="shopIcon" alt="待处理图标" />
                                        <div className="data-content">
                                            <div className="shopValue">{apiData7.todayFinishNum}</div>
                                            <div className="shopText">今日完工量</div>
                                        </div>
                                    </div>
                                    <div className="data-item item3">
                                        <img src={rightLogo} className="shopIcon" alt="待处理图标" />
                                        <div className="data-content">
                                            <div className="shopValue">{apiData7.todayWaitNum}</div>
                                            <div className="shopText">待处理</div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="boxall">
                                    <div className="alltitle">
                                        <img src={elseIcon} alt="站点图标" />
                                        维修状态分析(单)
                                    </div>
                                    <div className="newStatus">
                                        <ReactECharts className="sg2" option={option3} style={{ flex: 1 }}
                                            opts={{ renderer: 'svg', devicePixelRatio: 2 }}
                                        />
                                        <div className="task-status" style={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0 }}>
                                            <div className="pending-task">
                                                <img className="statusIcon" src={logo3_1} alt="待处理图标" />
                                                <div className="task-text">
                                                    <span className="task-status-label">待处理</span>
                                                    <div style={{ color: '#FDDD52' }}>
                                                        <span className="task-number" id="pending-number">{apiVal3.elseVal}</span>
                                                        <span className="task-percentage" id="pending-percentage">/ {apiVal3.elseValPercentage}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="finish-task">
                                                <img className="statusIcon" src={logo3_2} alt="已完工图标" />
                                                <div className="task-text">
                                                    <span className="task-status-label">已完工</span>
                                                    <div style={{ color: '#3ffb82' }}>
                                                        <span className="task-number" id="finish-number">{apiVal3.finishVal}</span>
                                                        <span className="task-percentage" id="finish-percentage">/ {apiVal3.finishValPercentage}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="completed-task">
                                                <img className="statusIcon" src={logo3_3} alt="已完结图标" />
                                                <div className="task-text">
                                                    <span className="task-status-label">已完结</span>
                                                    <div style={{ color: '#30FFF3' }}>
                                                        <span className="task-number" id="completed-number">{apiVal3.okVal}</span>
                                                        <span className="task-percentage" id="completed-percentage">/ {apiVal3.okValPercentage}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="boxfoot"></div>
                                </div>
                                <div className="boxall">
                                    <div className="alltitle">
                                        <img src={elseIcon} alt="站点图标" />
                                        维修类型分析
                                    </div>
                                    <div className="allnav">
                                        <ReactECharts option={option2}
                                            opts={{ renderer: 'svg', devicePixelRatio: 2 }}
                                        />
                                    </div>
                                    <div className="boxfoot"></div>
                                </div>
                                <div className="boxall">
                                    <div className="alltitle">
                                        <img src={elseIcon} alt="站点图标" />
                                        故障类型分析
                                    </div>
                                    <div className="allnav" id="echart6">
                                        <ReactECharts
                                            ref={chartRef6}
                                            option={option6}
                                            onChartReady={(chart) => {
                                                chart.setOption({
                                                    renderer: 'svg',
                                                    devicePixelRatio: window.devicePixelRatio || 2
                                                });
                                            }}
                                        />
                                    </div>
                                    <div className="boxfoot"></div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <ChartGpt />
                </div>
            </div>
        </div>
    )
}